export default __webpack_public_path__ + "static/android_logo-53c394a7d522298d8335a955313a5158.png";